import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./Auth";

//Route only if we have a logged in user.
//Which in our case is the only user, admin.
export const PrivateRoute = ({ children }) => {
    const { currentUser } = useContext(AuthContext);
    
    //!! means convert object to True or False, so !!currentUser means if a user exists, it is converted to true.
    return !!currentUser ? children : <Navigate to="/404" />;
};

export default PrivateRoute;
